<template>
  <div class="v-pano">
  </div>
</template>

<script>
import Marzipano from 'marzipano'

export default {
  name: 'Panorama',
  props: {
    source: {
      type: String,
      default: ''
    },
    settings: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      // size: {
      //   width: this.width,
      //   height: this.height
      // },
      viewer: null,
      panorama: null
    }
  },
  mounted () {
    // if (this.width === undefined || this.height === undefined) {
    //   this.$nextTick(() => {
    //     this.size = {
    //       width: this.$el.offsetWidth,
    //       height: this.$el.offsetHeight
    //     }
    //   })
    // }
    // Create viewer.
    this.viewer = new Marzipano.Viewer(this.$el)

    // Create source.
    let source = Marzipano.ImageUrlSource.fromString(
      this.source
    )

    // Create geometry.
    let geometry = new Marzipano.EquirectGeometry([{ width: 4000 }])

    // Create view.
    let yaw = this.settings && this.settings.position ? this.settings.position : 0
    let limiter = Marzipano.RectilinearView.limit.traditional(1024, 100 * Math.PI / 180)
    let view = new Marzipano.RectilinearView({ yaw: yaw * 2 * Math.PI }, limiter)

    // Create scene.
    let scene = this.viewer.createScene({
      source: source,
      geometry: geometry,
      view: view,
      pinFirstLevel: true
    })

    // Display scene.
    scene.switchTo()
  }
}
</script>

<style lang="css">
.v-pano {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
}
</style>
